import { render } from "./role-assign-scope.vue?vue&type=template&id=3bc70ae0"
import script from "./role-assign-scope.vue?vue&type=script&lang=js"
export * from "./role-assign-scope.vue?vue&type=script&lang=js"

import exportComponent from "/Users/dereklei/Documents/DotnetProjects/WorkProjects/OAuth.Server.OneId/OAuth.Server/Web/Saas.Admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__